import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import qs from 'qs';

import App from './App';

const {gKey} = qs.parse(window.location.search, {ignoreQueryPrefix: true});

/**
 * Initialize the AGN widget.
 *
 * @param {string} elementId The element that should contain the widget.
 * @param {object} props Various app properties to pass through.
 *
 * @returns {void}
 */
export const init = ({elementId, props}) => {
  ReactDOM.render(<App gKey={gKey} {...props} />,
    document.getElementById(elementId));
};
